import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'

const RelatedArticle = ({
  articleImage,
  name,
  url
}) =>
  <Article>
    <Image src={ articleImage } />
    <Description>
      <VerticalAligner>
        <StyledLink to={ url }>{ name } <RedCaretIcon asset="arrow-red-right" /></StyledLink>
      </VerticalAligner>
    </Description>
  </Article>

export default RelatedArticle

RelatedArticle.propTypes = {
  articleImage: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string
}

const Article = styled.div`
  width: 312px;
  display: inline-block;
  margin: 0 12px 24px;
`

const Image = styled.img`
  display: block;
  width: 312px;
  height: 176px;
`

const Description = styled.div`
  text-align: center;
  height: 70px;
  background-color: ${Theme.colors.black};
  overflow: hidden;
  padding: 0 20px;
  display: table;
  vertical-align: middle;
  width: 100%;
  ${Media.mobile`
    padding: 0 8px;
  `}
`

const RedCaretIcon = styled(Icon)`
  margin-left: 5px;
`

const VerticalAligner = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const StyledLink = styled(Link)`
  display: inline-block;
  color: ${Theme.colors.white};
  text-decoration: underline;
  vertical-align: middle;
  text-align: left;
  overflow: hidden;
  max-height: 50px;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
`
